<template>
  <!-- START BLOG -->
  <section class="section bg-light pt-5 scroll-select" id="blog">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Blog</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center font-secondary padding-t-30"
          >
            Acompanhe nossas dicas de carreira, empreendedorismo e inovação!
          </p>
        </div>
      </div>

      <div class="row margin-t-30">
        <div class="col-lg-4">
          <div class="blog-box margin-t-30 hover-effect">
            <img src="images/blog/img-1.jpg" class="img-fluid" alt="" />
            <div>
              <h5 class="mt-4 text-muted">Empreendedorismo</h5>
              <h4 class="mt-3">
                <a href="" class="blog-title">
                  10 diconas para arrebentar com seu novo negócio
                </a>
              </h4>
              <p class="text-muted">
                Começar um negócio não das coisas mais simples de se fazer. É
                preciso empenho, dedi...
              </p>
              <div class="mt-3">
                <a href="" class="read-btn"
                  >Leia Mais <i class="mdi mdi-arrow-right"></i
                ></a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="blog-box margin-t-30 hover-effect">
            <img src="images/blog/img-2.jpg" class="img-fluid" alt="" />
            <div>
              <h5 class="mt-4 text-muted">Inovação</h5>
              <h4 class="mt-3">
                <a href="" class="blog-title">Como mudar paradigmas</a>
              </h4>
              <p class="text-muted">
                Num mundo de constante evolução e mudança, as ideias novas
                parecem cada mais mais raras...
              </p>
              <div class="mt-3">
                <a href="" class="read-btn"
                  >Leia Mais <i class="mdi mdi-arrow-right"></i
                ></a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="blog-box margin-t-30 hover-effect">
            <img src="images/blog/img-3.jpg" class="img-fluid" alt="" />
            <div>
              <h5 class="mt-4 text-muted">Inovação</h5>
              <h4 class="mt-3">
                <a href="" class="blog-title"
                  >Qual a diferença entre inventar e inovar?</a
                >
              </h4>
              <p class="text-muted">
                Inovação é um conceito muito usado e pouco compreendido. Desde a
                primeira revolu...
              </p>
              <div class="mt-3">
                <a href="" class="read-btn"
                  >Leia Mais <i class="mdi mdi-arrow-right"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END BLOG -->
</template>

<script>
export default {
  name: "Blog",
  props: {}
};
</script>
